import { FC } from 'react'
import { Route, Routes } from 'react-router-dom'
import {
  AuthForm,
  EmulateUserForm,
  ForgotPassword,
  RegisterVerifiedUserForm,
  TermsForm,
} from '../components'
import { AuthLayout } from './AuthLayout'
import { AUTH_ROUTES } from './consts'

export const AuthRoutes: FC = ({ children }) => {
  return (
    <Routes>
      <Route path={AUTH_ROUTES.LOGIN} element={<AuthLayout />}>
        <Route index element={<AuthForm />} />
      </Route>
      <Route path={AUTH_ROUTES.TERMS} element={<AuthLayout variant="content" />}>
        <Route index element={<TermsForm />} />
      </Route>
      <Route path={AUTH_ROUTES.FORGOT_PASSWORD} element={<AuthLayout />}>
        <Route index element={<ForgotPassword />} />
      </Route>
      <Route path={AUTH_ROUTES.EMULATE_USER} element={<AuthLayout />}>
        <Route index element={<EmulateUserForm />} />
      </Route>
      <Route path={AUTH_ROUTES.REGISTRATION} element={<AuthLayout />}>
        <Route index element={<RegisterVerifiedUserForm />} />
      </Route>
      {children}
    </Routes>
  )
}
